var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('i',{staticClass:"icon-note"}),_c('strong',[_vm._v(_vm._s(_vm.$t('form.create', { item: _vm.$t('ranges.range') })))])]),_c('b-card-body',[_c('Form',{on:{"onSubmit":_vm.onSubmit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }